export default __webpack_public_path__ + "static/media/Shadow's Mask of the Sundered Crown.d959d994.jpg";